import { StandardShell } from "./StandardShell";

export const SHELL_REGISTRY = {
  standard: StandardShell,
} as const;

export type ShellName = keyof typeof SHELL_REGISTRY;

export function resolveShell(name?: string) {
  if (name && name in SHELL_REGISTRY) {
    return SHELL_REGISTRY[name as ShellName];
  }
  if (name) {
    console.warn(
      `[roz-sdk-ui] неизвестный shell "${name}", используется standard`
    );
  }
  return SHELL_REGISTRY.standard;
}
